import { ADD_ACL, CREATEINSTANCE_SUCCESS } from '../actions';

const createInstanceForms = {
  aclEntry: (state, action) => {
    switch (action.type) {
      case ADD_ACL:
        return undefined;
      default:
        return state;
    }
  },
  create: (state, action) => {
    switch (action.type) {
      case CREATEINSTANCE_SUCCESS:
        return undefined;
      default:
        return state;
    }
  },
};

export default createInstanceForms;
